<template>
  <a-layout class="wait-application-box">
    <a-card class="create-application" :class="fromLocation==='msg'?'msg-create-application':''" :bordered=false :loading="loading">
      <div class="page-title" slot="title" v-if="pageLayout.pageTitle">
        <a-icon style="cursor:pointer;" type="left-circle" @click="back" v-if="fromLocation==='app'" />
        <div>{{pageLayout.pageTitle}}</div>
        <span v-if="params.status" class="page-status" :class="{'page-status-yellow':params.status==='审批中','page-status-green':params.status==='审批通过'||params.status==='付款成功','page-status-red':params.status==='审批拒绝'||params.status==='付款失败','page-status-gray':params.status==='已撤回'}">{{params.status}}</span>
        <!-- <svg-ic-close class="page-close" @click="close" v-if="fromLocation==='msg'"></svg-ic-close> -->
      </div>
      <div slot="extra" style="cursor:pointer" class="extra" v-if="pageLayout.functions">
        <span v-for="(item,index) in pageLayout.functions" :key="index" style="margin-left:17px;">
          <span class="extra-trigger" @click="print" v-if="item.action==='print'">
            <a-icon style="cursor:pointer" slot="suffixIcon" :component="'SvgIcFile'" />打印
          </span>
        </span>
      </div>
      <div v-for="(layout,index) in pageLayout.contents" :key="index" v-if="loadedInfo && !loading">
        <common-form :ref="'commonForm'" :layout="layout" v-if="layout.type==='commonForm'" :params="layout.field && params[layout.field]?params[layout.field]:{}" :can-edit="canEdit" :need-id="true" @changed-fields="onFieldChange"></common-form>
        <multi-form :ref="'multiForm'" :layout="layout" v-if="layout.type==='multiForm'" :params="layout.field && params[layout.field]?params[layout.field]:[]" :can-edit="canEdit" :need-id="true" @changed-fields="onFieldChange"></multi-form>
        <summation :layout="layout" v-if="layout.type==='summation'" :params="params[layout.field]?params[layout.field]:{}" :all-params="paramsBackup" :from-detail="true" @changed-fields="setSummationInfo"></summation>
        <upload v-if="layout.type==='upload'" :layout="layout" :params="params[layout.field]?params[layout.field]:[]" :can-edit="canEdit"></upload>
        <a-divider/>
      </div>
      <approval-flow :params="approvalFlowInfo" :init-text="'审批流数据加载中...'" v-if="loadedInfo && !loading"></approval-flow>
      <a-row class="footer" v-if="params.process_status && loadedInfo && !loading" style="margin-top:20px;" :class="fromLocation==='msg'?'msg-submit-box':''">
        <a-textarea v-if="fromLocation==='msg'" class="msg-textarea" placeholder="请输入审批意见" v-model="comment"></a-textarea>
        <a-col :xs="6" :sm="4"></a-col>
        <a-col :xs="14" :sm="20" :style="fromLocation==='msg'?'text-align:right':''">
          <a-button type="primary" @click="approval(1)" style="width:120px;margin-right:18px;">批准</a-button>
          <a-button @click="approval(0)" style="width:120px;margin-right:18px;">退回</a-button>
          <a-button @click="visibleComment = true" style="width:120px;">评论</a-button>
        </a-col>
      </a-row>
      <div style="text-align:center" v-if="!loadedInfo || loading">
        <a-spin tip="数据加载中..."></a-spin>
      </div>
    </a-card>
    <form-modal :basic-modal="approvalModal" :form-layout="approvalInfolModal" :disabled-ok-btn="disabledSubmit" @submit="approvalModalSubmit" @cancel="approvalModalCancel"></form-modal>
    <comment-and-copy :visible="visibleComment" @cancel="visibleComment = false" @reload="reload"></comment-and-copy>
  </a-layout>
</template>

<script>
import * as dd from "dingtalk-jsapi";
import UUID from "uuidjs";
import SvgIcBackbtn from "../../assets/svg/ic-left-circle-o.svg";
import SvgIcFile from "../../assets/svg/ic-file-o.svg";
import CommonForm from "../../components/CommonForm.vue";
import MultiForm from "../../components/MultiForm.vue";
import Summation from "../../components/Summation.vue";
import ApprovalFlow from "../../components/ApprovalFlow.vue";
import FormModal from "../../components/FormModal.vue";
import Upload from "../../components/Upload.vue";
import { setTimeout } from "timers";
import LayoutConfig from "../../utils/LayoutConfig.js";
import { layoutConfig } from "../../utils/mockData.js";
import {
  backInfoFormModal,
  agreeInfoFormModal
} from "../../data/formModalConfigs.js";
import {
  getProPaymentLayout,
  getProPaymentDetail,
  approvalApplication,
  getDetailApprovalFlow,
  printUrl
} from "../../services/CommonService.js";

export default {
  components: {
    SvgIcBackbtn,
    SvgIcFile,
    CommonForm,
    MultiForm,
    Summation,
    ApprovalFlow,
    FormModal,
    Upload
  },
  data() {
    return {
      canEdit: false,
      breadcrumb: [
        {
          label: "待我审批",
          path: ""
        }
      ],
      cardHeight: 0,
      applicationTitle: "发起付款申请",
      params: {},
      paramsBackup: {},
      // allParams: {},
      requestParams: {},
      loading: false,
      loadedInfo: false,
      pageLayout: layoutConfig,
      approvalModal: {
        visible: false,
        title: "打回",
        contentTitle: "你确定拒绝付款申请吗?",
        width: 560,
        formItemLayout: {
          layout: "vertical",
          labelCol: {
            xs: { span: 24 },
            sm: { span: 24 }
          },
          wrapperCol: {
            xs: { span: 24 },
            sm: { span: 24 }
          }
        }
      },
      approvalInfolModal: [],
      approvalFlowInfo: [],
      comment: undefined,
      fromLocation: undefined,
      disabledSubmit: false,
      visibleComment: false
    };
  },

  created() {
    this.id = this.$route.query.id;
    Promise.all([this.getProPaymentDetail()]).then(() => {
      this.fetchLayout();
    });
    this.fetchApprovalFlow();
    this.fromLocation =
      window.location.href.indexOf("fromLocation=msg") === -1 ? "app" : "msg"; //区别是从钉钉消息进入还是应用或者浏览器
  },
  mounted() {},

  computed: {},

  methods: {
    fetchApprovalFlow() {
      this.approvalFlowInfo = [];
      getDetailApprovalFlow({ id: this.$route.query.id }).then(res => {
        if (res.status === "success") {
          res.data.forEach((item, index) => {
            this.$set(this.approvalFlowInfo, index, item);
          });
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    onFieldChange(e) {
      this.params = Object.assign({}, this.params, e);
      this.requestParams = _.cloneDeep(this.params);
    },
    setSummationInfo(e) {
      this.summationInfo = e;
    },
    fetchLayout() {
      this.loading = true;
      getProPaymentLayout({
        id: this.id,
        type: "detail",
        menu_type: 2,
        ding_msg_switch:
          window.location.href.indexOf("fromLocation=msg") !== -1 ? 1 : 0
      }).then(res => {
        if (res.status === "success") {
          this.pageLayout = res.data;
          this.loading = false;
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    getProPaymentDetail() {
      this.loadedInfo = false;
      getProPaymentDetail(this.id, { type: "detail", menu_type: 2 }).then(
        res => {
          if (res.status === "success") {
            this.params = Object.assign({}, this.params, res.data);
            this.paramsBackup = _.cloneDeep(this.params);
            this.loadedInfo = true;
          } else {
            this.$Message.error(res.message);
          }
        }
      );
    },
    back() {
      this.$router.replace({
        name: "waitApprovalList",
      });
    },
    approval(e) {
      let validateResult = true;
      if (e) {
        this.$refs.commonForm.forEach(item => {
          if (!item.validateFields()) {
            validateResult = false;
          }
        });
        this.$refs.multiForm.forEach(item => {
          if (!item.validateFields()) {
            validateResult = false;
          }
        });
      }
      if (!validateResult) {
        return;
      }
      if (this.fromLocation === "msg") {
        let params = {
          applyId: this.$route.query.id,
          status: e ? 2 : 3,
          comment: this.comment,
          applyType: 8
        };
        if (params.status === 2 && this.requestParams) {
          params = { ...this.requestParams, ...params };
        }
        approvalApplication(params).then(res => {
          if (res.status === "success") {
            this.$Message.success("审批成功");
            location.reload();
          } else {
            this.$Message.error(res.message);
          }
        });
      } else {
        this.disabledSubmit = false;
        this.approvalModal.visible = true;
        if (e) {
          this.approvalInfolModal = agreeInfoFormModal;
          this.approvalModal.title = "同意";
          this.approvalModal.contentTitle = "你确定同意此付款申请吗";
          this.approvalStatus = 2;
        } else {
          this.approvalInfolModal = backInfoFormModal;
          this.approvalModal.title = "拒绝";
          this.approvalModal.contentTitle = "你确定拒绝此付款申请吗";
          this.approvalStatus = 3;
        }
      }
    },
    approvalModalSubmit(e) {
      let params = {
        applyId: this.$route.query.id,
        status: this.approvalStatus,
        comment: e.reason,
        applyType: 8
      };
      if (this.approvalStatus === 2 && this.requestParams) {
        params = { ...this.requestParams, ...params };
      }
      this.disabledSubmit = true;
      approvalApplication(params).then(res => {
        if (res.status === "success") {
          this.approvalModal.visible = false;
          this.$Message.success("审批成功");
          this.back();
          this.disabledSubmit = false;
        } else {
          this.$Message.error(res.message);
          this.disabledSubmit = false;
        }
      });
    },
    approvalModalCancel() {
      this.approvalModal.visible = false;
      this.disabledSubmit = false;
    },
    print() {
      let url = `${window.location.origin}/api/fas/project-payment/${
        this.$route.query.id
      }/pdf`;
      url.replace(" ", "");
      location.href = url;
    },
    close() {
      dd.biz.navigation.quit();
    },

    reload() {
      this.visibleComment = false;
      this.fetchApprovalFlow();
    }
  }
};
</script>

<style lang="less">
.wait-application-box {
  padding: 16px;
}
</style>
